<template>
  <div class="login-page">

    <div class="overlay">

      <div class="container">

        <div class="row min-vh-100 align-items-center justify-content-center">

          <div class="col-12 col-md-10 col-lg-8">

            <div class="login-wrapper">

              <!-- PARTIE GAUCHE -->
              <div class="login-branding d-none d-lg-flex">

                <div class="branding-content">

                  <img
                    src="@/assets/lamien_consulting.jpeg"
                    alt="Logo"
                    class="logo-medical"
                  >

                  <div class="medical-badge">
                    <i class="bi bi-heart-pulse-fill"></i>
                  </div>

                  <h1>
                    Lamien Consulting
                  </h1>

                  <p>
                    Solution intelligente de gestion
                    des matériels et équipements médicaux.
                  </p>

                  <div class="features">

                    <div>
                      <i class="bi bi-shield-check"></i>
                      Sécurité avancée
                    </div>

                    <div>
                      <i class="bi bi-box-seam"></i>
                      Gestion du stock
                    </div>

                    <div>
                      <i class="bi bi-graph-up-arrow"></i>
                      Tableau de bord intelligent
                    </div>

                  </div>

                </div>

              </div>

              <!-- PARTIE DROITE -->
              <div class="login-form-side">

                <div class="login-card">

                  <div class="text-center mb-4">

                    <h2 class="login-title">
                      Connexion
                    </h2>

                    <p class="login-subtitle">
                      Accédez à votre espace de gestion
                    </p>

                  </div>

                  <div
                    v-if="globalError"
                    class="alert alert-danger"
                  >
                    {{ globalError }}
                  </div>

                  <form @submit.prevent="login">

                    <!-- EMAIL -->
                    <div class="mb-3">

                      <label class="form-label">
                        Adresse email
                      </label>

                      <div class="input-group">

                        <span class="input-group-text">
                          <i class="bi bi-envelope-fill"></i>
                        </span>

                        <input
                          type="email"
                          v-model.trim="email"
                          class="form-control medical-input"
                          :class="{ 'is-invalid': error.email }"
                          placeholder="admin@Lamien Consulting.com"
                          :disabled="isLoading"
                        >

                      </div>

                      <div class="invalid-feedback d-block">
                        {{ error.email }}
                      </div>

                    </div>

                    <!-- PASSWORD -->
                    <div class="mb-4">

                      <label class="form-label">
                        Mot de passe
                      </label>

                      <div class="input-group">

                        <span class="input-group-text">
                          <i class="bi bi-shield-lock-fill"></i>
                        </span>

                        <input
                          :type="showPassword ? 'text' : 'password'"
                          v-model.trim="password"
                          class="form-control medical-input"
                          :class="{ 'is-invalid': error.password }"
                          placeholder="Votre mot de passe"
                          :disabled="isLoading"
                        >

                        <button
                          class="btn btn-password"
                          type="button"
                          @click="showPassword=!showPassword"
                        >
                          <i
                            :class="showPassword
                            ? 'bi bi-eye-slash'
                            : 'bi bi-eye'"
                          ></i>
                        </button>

                      </div>

                      <div class="invalid-feedback d-block">
                        {{ error.password }}
                      </div>

                    </div>

                    <div
                      class="d-flex justify-content-between align-items-center mb-4"
                    >

                      <div class="form-check">

                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="remember"
                          v-model="remember"
                        >

                        <label
                          class="form-check-label"
                          for="remember"
                        >
                          Se souvenir de moi
                        </label>

                      </div>

                      <span class="version">
                        Version 1.0
                      </span>

                    </div>

                    <button
                      type="submit"
                      class="btn btn-login w-100"
                      :disabled="isLoading"
                    >

                      <span v-if="isLoading">

                        <span
                          class="spinner-border spinner-border-sm me-2"
                        ></span>

                        Connexion...

                      </span>

                      <span v-else>

                        <i
                          class="bi bi-box-arrow-in-right me-2"
                        ></i>

                        Accéder au système

                      </span>

                    </button>

                  </form>

                </div>

              </div>

            </div>

            <div class="footer-text text-center mt-4">

              © {{ currentYear }} Lamien Consulting

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: "LoginPage",

  data() {
    return {
      email: "",
      password: "",
      remember: false,
      showPassword: false,
      isLoading: false,

      globalError: this.$route.query.message || "",

      error: {
        email: "",
        password: ""
      }
    };
  },

  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  },

  methods: {

    validate() {

      this.globalError = "";

      this.error = {
        email: "",
        password: ""
      };

      // EMAIL
      if (!this.email) {

        this.error.email = "L'email est requis.";

      } else {

        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!re.test(this.email)) {
          this.error.email = "Adresse email invalide.";
        }

      }

      // PASSWORD
      if (!this.password) {

        this.error.password =
          "Le mot de passe est requis.";

      }

      return !this.error.email &&
             !this.error.password;

    },

    async login() {

      if (!this.validate() || this.isLoading) {
        return;
      }

      this.isLoading = true;
      this.globalError = "";

      try {

        const result =
          await this.$store.dispatch(
            "authenticate",
            {
              email: this.email,
              password: this.password,
              remember: this.remember
            }
          );

        if (result.success) {

          this.$router.push("/");

        } else {

          this.globalError =
            "Identifiants incorrects.";

        }

      } catch (e) {

        this.globalError =
          "Impossible de se connecter au serveur.";

      } finally {

        this.password = "";
        this.isLoading = false;

      }

    }

  }

};
</script>

<style scoped>

.login-page{
  min-height:100vh;

  background:url('')
  center center/cover no-repeat;

  position:relative;
}

.overlay{
  position:absolute;
  inset:0;

  background:
  linear-gradient(
    135deg,
    rgba(9,30,66,.95),
    rgba(15,76,129,.90)
  );
}

.login-wrapper{
  display:flex;

  overflow:hidden;

  border-radius:30px;

  background:white;

  box-shadow:
  0 25px 60px rgba(0,0,0,.25);
}

.login-branding{

  width:45%;

  color:white;

  padding:50px;

  background:
  linear-gradient(
    135deg,
    #0F4C81,
    #1976D2
  );

  align-items:center;
  justify-content:center;
}

.branding-content{
  text-align:center;
}

.logo-medical{
  width:120px;
  height:120px;
  object-fit:contain;
}

.medical-badge{

  width:90px;
  height:90px;

  margin:25px auto;

  border-radius:50%;

  background:white;

  color:#0F4C81;

  display:flex;
  align-items:center;
  justify-content:center;

  font-size:40px;
}

.branding-content h1{

  font-weight:800;

  margin-bottom:15px;
}

.features{

  margin-top:40px;
}

.features div{

  margin-bottom:15px;

  font-size:15px;
}

.features i{
  margin-right:10px;
}

.login-form-side{

  flex:1;

  padding:50px;
}

.login-card{
  border:none;
}

.login-title{

  color:#0F4C81;

  font-weight:700;
}

.login-subtitle{

  color:#64748B;
}

.input-group-text{

  background:#f8fafc;

  border-right:none;
}

.medical-input{

  height:55px;

  border-left:none;
}

.medical-input:focus{

  box-shadow:
  0 0 0 4px rgba(25,118,210,.15);

  border-color:#1976D2;
}

.btn-password{

  border:1px solid #ced4da;

  border-left:none;

  background:#fff;
}

.btn-login{

  height:58px;

  border:none;

  border-radius:14px;

  color:white;

  font-weight:700;

  background:
  linear-gradient(
    135deg,
    #0F4C81,
    #2196F3
  );

  transition:.3s;
}

.btn-login:hover{

  transform:translateY(-2px);

  box-shadow:
  0 12px 25px rgba(33,150,243,.35);
}

.version{
  color:#94A3B8;
}

.footer-text{
  color:white;
}

@media(max-width:991px){

  .login-wrapper{
    display:block;
  }

  .login-form-side{
    padding:30px;
  }

}

</style>